import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import RoutingUtil from 'src/utils/RoutingUtil';
import RolePermissionsForm from './RolePermissionsForm';

const data = [
    {
        link: RoutingUtil.rolePermissionsUrl(),
        title: 'Role Permission Manger', // tab title
        component: RolePermissionsForm,
    },
    // {
    //     link: RoutingUtil.userPermissionsUrl(),
    //     title: 'User Permission Manger', // tab title
    //     component: <h1>Hello</h1>,
    // },
];

const PermissionsContainer = () => (
    <CrudLayoutContainer
        title="Permission Manager"
        tabs={data}
        routes={data}
    />
);

export default PermissionsContainer;
